<div class="flex flex-col">
    <b>{{ label }}</b>

    <ng-container *ngIf="isList && items; else noList">
        <span *ngIf="items?.length; else emptyValue">{{ items | slice:0:currentSlice | listValueToString }}</span>
        <a *ngIf="items?.length > currentSlice" (click)="viewAll()">Show {{ items?.length - currentSlice }} more...</a>
        <ng-template #emptyValue>
            <span>{{ emptyValueMessage }}</span>
        </ng-template>
    </ng-container>

    <ng-template #noList>
        <span>{{ value }}</span>
    </ng-template>    
</div>